(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["snc-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ─── Footer Legacy Club — Klaviyo Client API v3 subscribe ─────────────────
       Intercepts the footer signup form submit, calls Klaviyo directly to
       subscribe the email to list TWy4DM, then shows a success state.
       The native Shopify form is NOT submitted (no redirect; pure JS flow).
    ──────────────────────────────────────────────────────────────────────────── */

    var KLAVIYO_COMPANY_ID = 'X2CxYi';
    var KLAVIYO_LIST_ID    = 'TWy4DM';
    var KLAVIYO_ENDPOINT   =
      'https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID;

    /* Locate every footer Legacy Club form on the page (handles multi-section edge cases). */
    var forms = document.querySelectorAll('.snc-footer__legacy-club-form');
    if (!forms.length) return;

    forms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var emailInput = form.querySelector('input[type="email"]');
        if (!emailInput || !emailInput.value.trim()) return;

        var email      = emailInput.value.trim();
        var nameInput  = form.querySelector('input[type="text"]');
        var firstName  = nameInput ? nameInput.value.trim() : '';
        var submitBtn  = form.querySelector('.snc-footer__legacy-submit');
        var fieldsDiv  = form.querySelector('.snc-footer__legacy-fields');

        /* Disable button while in-flight */
        if (submitBtn) {
          submitBtn.disabled    = true;
          submitBtn.style.opacity = '0.55';
        }

        fetch(KLAVIYO_ENDPOINT, {
          method: 'POST',
          headers: {
            'content-type': 'application/json',
            'revision':      '2024-10-15'
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: Object.assign({ email: email }, firstName ? { first_name: firstName } : {})
                  }
                }
              },
              relationships: {
                list: { data: { type: 'list', id: KLAVIYO_LIST_ID } }
              }
            }
          })
        })
        .then(function (res) {
          if (res.ok || res.status === 202) {
            /* Success — hide the fields, show success message */
            if (fieldsDiv) fieldsDiv.style.display = 'none';

            var successMsg = form.querySelector('.snc-footer__legacy-message');
            if (!successMsg) {
              successMsg = document.createElement('div');
              successMsg.className = 'snc-footer__legacy-message';
              form.appendChild(successMsg);
            }
            successMsg.textContent = 'Thank you — you\'ve joined the Legacy Club.';
            successMsg.style.display = 'block';
          } else {
            /* Non-2xx response: re-enable button, silent fail */
            if (submitBtn) {
              submitBtn.disabled    = false;
              submitBtn.style.opacity = '';
            }
          }
        })
        .catch(function () {
          /* Network error: re-enable button, silent fail */
          if (submitBtn) {
            submitBtn.disabled    = false;
            submitBtn.style.opacity = '';
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snc-legacy-club-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-snc-legacy-popup-root]');
    if (!root) return;

    var cookieName   = root.getAttribute('data-cookie-name') || 'snc_legacy_club_dismiss';
    var cookieDays   = parseInt(root.getAttribute('data-cookie-days'), 10);   // 0 = never set cookie
    var maxAge       = parseInt(root.getAttribute('data-cookie-max-age'), 10); // seconds
    var triggerDelay = parseInt(root.getAttribute('data-trigger-delay-ms'), 10); // 0 = immediate

    // ── Helpers ──────────────────────────────────────────────────────────────

    function getCookie(name) {
      var match = document.cookie.match(
        new RegExp('(?:^|; )' + name.replace(/[$()*+.?[\\\]^{|}]/g, '\\$&') + '=([^;]*)')
      );
      return match ? decodeURIComponent(match[1]) : null;
    }

    function setDismissCookie() {
      // cookie_days === 0 means "always show" — never write a dismiss cookie
      if (cookieDays === 0) return;
      document.cookie =
        cookieName + '=1;max-age=' + maxAge + ';path=/;SameSite=Lax';
    }

    // ── Open / Close ─────────────────────────────────────────────────────────

    function openPopup() {
      if (root.getAttribute('data-popup-open') === 'true') return;
      detachTriggers();
      root.removeAttribute('hidden');
      root.setAttribute('data-popup-open', 'true');
      var overlay = root.querySelector('[data-snc-legacy-popup-overlay]');
      if (overlay) overlay.setAttribute('aria-hidden', 'false');
      // Focus the email input, or the dialog itself for accessibility
      var email  = root.querySelector('input[type="email"]');
      var dialog = root.querySelector('[data-snc-legacy-popup-dialog]');
      if (email)        { email.focus(); }
      else if (dialog)  { dialog.focus(); }
    }

    function closePopup() {
      if (root.getAttribute('data-popup-closing') === 'true') return;
      root.setAttribute('data-popup-open', 'false');
      root.setAttribute('data-popup-closing', 'true');
      var ov = root.querySelector('[data-snc-legacy-popup-overlay]');
      if (ov) ov.setAttribute('aria-hidden', 'true');
      setDismissCookie();
      detachTriggers();
      setTimeout(function () {
        root.setAttribute('hidden', '');
        root.removeAttribute('data-popup-closing');
      }, 360);
    }

    // ── Trigger logic ─────────────────────────────────────────────────────────
    // PRIMARY  : delay timer (fires triggerDelay ms after DOMContentLoaded)
    //            if triggerDelay === 0 → fires immediately (setTimeout 0)
    // SECONDARY: exit-intent (mouse leaves viewport through the top)

    var delayTimer = null;

    function detachTriggers() {
      clearTimeout(delayTimer);
      document.documentElement.removeEventListener('mouseleave', onExitIntent, false);
    }

    function onExitIntent(e) {
      if (typeof e.clientY === 'number' && e.clientY <= 0) openPopup();
    }

    function schedulePrimaryTrigger() {
      // triggerDelay === 0 → show on next tick so the page has painted
      var delay = (isNaN(triggerDelay) || triggerDelay < 0) ? 15000 : triggerDelay;
      delayTimer = setTimeout(openPopup, delay);
    }

    // ── Guard: cookie check (skip when cookie_days === 0) ────────────────────
    if (cookieDays !== 0 && getCookie(cookieName)) {
      root.setAttribute('hidden', '');
      return;
    }

    // ── Design-mode preview ───────────────────────────────────────────────────
    // Only open when the merchant clicks the section in the editor, not on load.
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      var edClose    = root.querySelector('[data-snc-legacy-popup-close]');
      var edOverlayEl = root.querySelector('[data-snc-legacy-popup-overlay]');

      function editorOpen() {
        root.removeAttribute('hidden');
        root.setAttribute('data-popup-open', 'true');
        var edOv = root.querySelector('[data-snc-legacy-popup-overlay]');
        if (edOv) edOv.setAttribute('aria-hidden', 'false');
      }

      function editorClose() {
        if (root.getAttribute('data-popup-closing') === 'true') return;
        root.setAttribute('data-popup-open', 'false');
        root.setAttribute('data-popup-closing', 'true');
        setTimeout(function () {
          root.setAttribute('hidden', '');
          root.removeAttribute('data-popup-closing');
        }, 360);
      }

      if (edClose)     edClose.addEventListener('click', editorClose);
      if (edOverlayEl) edOverlayEl.addEventListener('click', editorClose);

      // Open only when this section is selected in the editor
      document.addEventListener('shopify:section:select', function (e) {
        if (e.detail && e.detail.sectionId === '{{ section.id }}') editorOpen();
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.detail && e.detail.sectionId === '{{ section.id }}') editorClose();
      });

      return;
    }

    // ── Wire close controls ───────────────────────────────────────────────────
    var closeBtn  = root.querySelector('[data-snc-legacy-popup-close]');
    var overlayEl = root.querySelector('[data-snc-legacy-popup-overlay]');
    if (closeBtn)  closeBtn.addEventListener('click', closePopup);
    if (overlayEl) overlayEl.addEventListener('click', closePopup);

    var dlg = root.querySelector('[data-snc-legacy-popup-dialog]');
    if (dlg) {
      dlg.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); closePopup(); }
      });
    }

    // ── Start triggers ────────────────────────────────────────────────────────
    // Attach secondary exit-intent listener first, then schedule primary timer
    document.documentElement.addEventListener('mouseleave', onExitIntent, false);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', schedulePrimaryTrigger);
    } else {
      schedulePrimaryTrigger();
    }

    // ── Form submit → Klaviyo Client API (no native submit = no CAPTCHA) ───────
    var popupForm = root.querySelector('.snc-legacy-popup__form');
    if (popupForm && typeof fetch !== 'undefined') {
      popupForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var emailInput = popupForm.querySelector('input[type="email"]');
        if (!emailInput || !emailInput.value.trim()) return;
        var nameInput  = popupForm.querySelector('input[type="text"]');
        var firstName  = nameInput ? nameInput.value.trim() : '';
        var submitBtn = popupForm.querySelector('button[type="submit"]');
        if (submitBtn) { submitBtn.disabled = true; submitBtn.style.opacity = '0.55'; }
        var profileAttrs = { email: emailInput.value.trim(), properties: { source: 'Legacy Club Pop-up' } };
        if (firstName) profileAttrs.first_name = firstName;
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=X2CxYi', {
          method: 'POST',
          headers: { 'content-type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: profileAttrs
                  }
                }
              },
              relationships: {
                list: { data: { type: 'list', id: 'TWy4DM' } }
              }
            }
          })
        }).then(function (res) {
          if (res.ok || res.status === 202) {
            var fields = popupForm.querySelector('.snc-legacy-popup__fields');
            if (fields) fields.style.display = 'none';
            var msg = document.createElement('p');
            msg.className = 'snc-legacy-popup__message snc-legacy-popup__message--success';
            msg.textContent = popupForm.getAttribute('data-success-message') || 'Thank you. You are on the list.';
            popupForm.appendChild(msg);
            setDismissCookie();
            setTimeout(closePopup, 2500);
          } else {
            if (submitBtn) { submitBtn.disabled = false; submitBtn.style.opacity = ''; }
          }
        }).catch(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.style.opacity = ''; }
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
